import { LanguageContextProvider } from './services/LanguageContextProvider';
import { ConsentContextProvider } from './services/ConsentContextProvider';
import { ConfiguratorContextProvider } from './services/ConfiguratorContextProvider';
import { CookieBanner } from './components/visualComponent/CookieBanner';
import { ConsentGate } from './components/ConsentGate';
import './App.css';
import { Router } from './router/Router';

function App() {
  return (
    <div className="App">
      <LanguageContextProvider>
        <ConsentContextProvider>
          <ConfiguratorContextProvider>
            <Router />
          </ConfiguratorContextProvider>
          <CookieBanner />
          <ConsentGate />
        </ConsentContextProvider>
      </LanguageContextProvider>
    </div>
  );
}

export default App;
